import styled from 'styled-components';

import HtmlContent from '@telialt/common-html-content/src/HtmlContent';
import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const LegalText = styled(HtmlContent)`
    font-size: ${getPurpurTypography('scale75')};
    line-height: 1.25rem;
    color: ${getPurpurColor('gray700')};
    margin-top: ${getPurpurSpacing('200')};
`;
